import { useState } from "react";
import SectionHeading from "@/components/base/SectionHeading";
import { faqs } from "@/mocks/topics";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="bg-background-100 px-4 py-14 md:px-8 md:py-20">
      <div className="mx-auto w-full max-w-8xl">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <SectionHeading
              eyebrow="常见问题"
              title="关于内容与整理方式"
              description="如果这里没有解答你的疑问，可以在「关于我们」页找到编辑部的联系方式。"
            />
            <div className="mt-6 rounded-lg border border-background-200 bg-background-50 p-5">
              <p className="text-sm leading-relaxed text-foreground-600">
                我们坚持：不编造、不夸大、不针对个人。所有示例内容均为虚构或匿名化样本。
              </p>
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
              {faqs.map((faq, index) => {
                const isOpen = openIndex === index;
                return (
                  <div key={faq.q}>
                    <button
                      type="button"
                      onClick={() => setOpenIndex(isOpen ? -1 : index)}
                      aria-expanded={isOpen}
                      className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-5 text-left transition-colors hover:bg-background-100 md:px-6"
                    >
                      <span className="font-heading text-base font-semibold text-foreground-950">
                        {faq.q}
                      </span>
                      <i
                        className={`shrink-0 text-lg text-primary-500 transition-transform duration-200 ${
                          isOpen ? "ri-subtract-line" : "ri-add-line"
                        }`}
                      />
                    </button>
                    {isOpen ? (
                      <div className="px-5 pb-5 md:px-6">
                        <p className="text-sm leading-relaxed text-foreground-600">{faq.a}</p>
                      </div>
                    ) : null}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}